import { cellValueFromGQL, FieldCellValueUI, gqlCellValueFromValue } from "../../Backend";
import { CaseInfo, Cell } from "../../generated/graphql";
import produce from "immer";
import { FormFieldCellEditor } from "./FormFieldCellEditor";
import { useContext } from "react";
import { FormFieldContext } from "contexts/FormFieldContext";
import { Box } from "@mui/material";

interface FormFieldValueGroupEditorProps {
  values: FieldCellValueUI[];
  groupId: number;
  caseInfo?: CaseInfo;
  cells: Cell[];
}

const FormFieldValueGroupEditor = (props: FormFieldValueGroupEditorProps) => {
  const { values, groupId, cells, caseInfo } = props;
  const ffContext = useContext(FormFieldContext);
  const handle = ffContext.valueGroupHandleForGroup(groupId);
  if (handle === undefined) {
    return <></>;
  }
  const [valueGroup, setValueGroupState] = handle;

  return (
    <>
      {values.map((_cv, cellIndex) => {
        const cell = cells[cellIndex];
        if (cell === undefined) return <></>;
        const thisCellState = valueGroup.values[cellIndex];
        const convertedValue = cellValueFromGQL(thisCellState?.value);
        const setError = (e) => {
          setValueGroupState(
            produce((draft) => {
              const c = draft.values[cellIndex];

              if (c !== undefined) {
                c.error = e;
              }
            })
          );
        };
        const setValue = (v) => {
          setValueGroupState(
            produce((draft) => {
              const prev = cellValueFromGQL(draft.values[cellIndex]?.value);
              const updated = gqlCellValueFromValue(cell?.type, v);
              const c = draft.values[cellIndex];

              if (c !== undefined) {
                c.value = updated;
              }

              const meaningfulUpdate: boolean = (prev || v) && prev !== v;
              if (meaningfulUpdate) draft.touched = true;
            })
          );
        };
        return (
          <Box key={cellIndex}>
            <FormFieldCellEditor
              caseInfo={caseInfo}
              cell={cell}
              tabular
              label={cell.name}
              disabled={false}
              error={thisCellState?.error}
              setError={setError}
              value={convertedValue}
              setValue={setValue}
            />
          </Box>
        );
      })}
    </>
  );
};

export default FormFieldValueGroupEditor;
